import { Anchor, Facebook, Instagram, Linkedin, Mail, Twitter } from "lucide-react";

interface LandingFooterProps {
  appName?: string;
}

const LandingFooter = ({ appName = "Hydranaut" }: LandingFooterProps) => {
  return (
    <footer className="relative border-t border-border/50 py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <Anchor className="w-6 h-6 text-primary" />
            <span className="text-lg font-bold font-space text-foreground">
              {appName}
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8 text-sm">
              <a 
                href="https://instagram.com/nimbitlabs" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg bg-card hover:bg-accent transition-all duration-300 text-muted-foreground hover:text-foreground shadow-sm hover:shadow-md hover:-translate-y-0.5"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://www.facebook.com/people/NimbitLabs/61584670823929" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg bg-card hover:bg-accent transition-all duration-300 text-muted-foreground hover:text-foreground shadow-sm hover:shadow-md hover:-translate-y-0.5"
                aria-label="Instagram"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://x.com/nimbitlabs" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg bg-card hover:bg-accent transition-all duration-300 text-muted-foreground hover:text-foreground shadow-sm hover:shadow-md hover:-translate-y-0.5"
                aria-label="X"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a 
                href="https://linkedin.com/company/nimbitlabs" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg bg-card hover:bg-accent transition-all duration-300 text-muted-foreground hover:text-foreground shadow-sm hover:shadow-md hover:-translate-y-0.5"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a 
                href="mailto:support@nimbitlabs.com"
                className="p-2.5 rounded-lg bg-card hover:bg-accent transition-all duration-300 text-muted-foreground hover:text-foreground shadow-sm hover:shadow-md hover:-translate-y-0.5"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
          </div>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            © 2025 {appName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
